import Vue from "vue";

Vue.component("ics-products", {
	props: ["placeholder", "language", "filteredIcsCodes", "notificationId", "hideDesc", "label", "isReadOnly", "list"],
	data() {
		return {
			icsVersionId: "V2",
			icsProducts: [],
			items: []
		};
	},
	computed: {
		icsCodeLabel() {
			return htmlEntity.decode(window.labels.icsCodes);
		},
		icsCodes: {
			get() {
				const text = this.filteredIcsCodes;
				if (!text) return [];
				return this.filteredIcsCodes;
			}
		}
	},
	methods: {
		getICSProductsForTreeSelect: function () {
			this.$services.icsProducts.getForTreeSelect({
				language: this.language,
				icsVersionCode: this.icsVersionId
			})
				.then((data) => {
					this.icsProducts = data.items;
					const items = [];

					data.items.forEach(function (value) {
						items.push({ id: value.id, code: value.code, description: value.description });
						value.children.forEach(function (t2) {
							items.push({ id: t2.id, code: t2.code, description: t2.description });
							t2.children.forEach(function (t3) {
								items.push({ id: t3.id, code: t3.code, description: t3.description });
								t3.children.forEach(function (t4) {
									items.push({ id: t4.id, code: t4.code, description: t4.description });
									t4.children.forEach(function (t5) {
										items.push({ id: t5.id, code: t5.code, description: t5.description });
									});
								});
							});
						});
					});

					this.items = items;
					this.$emit("update:list", items);
				});
		},
		updateSelectedIcsCodes: function (selectedICSCodes) {
			this.$emit("update:filteredIcsCodes", selectedICSCodes);	
		},
		getDataSourceTreeViewText: (dataSource, value) => {
			if (dataSource) {
				const items = dataSource.filter(i => value.includes(i.id));
				var returnValue = "";
				items.forEach(function (item) {
					returnValue += `${item.code} - ${item.description}; `;
				});
				return returnValue;
			}
			return "";
		},
		onDataChange: function(value){
			this.$emit('on-data-change', value)
		}
	},
	mounted() {
		this.getICSProductsForTreeSelect();
	},
	template: `
		<section>
			<wto-tree-select v-if="!isReadOnly" @on-data-change="onDataChange" ref="icsProductTreeSelect" @update-selected-options="updateSelectedIcsCodes" :filtered-options="icsCodes"  :options="icsProducts" :placeholder="placeholder" tree-id="ics-tree-select-container" />
			<div v-if="isReadOnly" class="textarea wto-textarea-editor-readonly" style="min-height: 60px !important">{{ getDataSourceTreeViewText(items, filteredIcsCodes) }}</div>
		</section>
	`
});